import React from 'react';
import { exitSheerIdFlow, SHEER_PAGE_TYPES } from 'Utils/SheerIdHelpers';
import './RestartVerificationButton.css';

const RestartVerificationButton = ({ setPage, isBango }) => {
  // TODO Add check to if military or first responder
  const onClick = async () => {
    await exitSheerIdFlow(!isBango);
    setPage(SHEER_PAGE_TYPES.MILITARY_FORM);
  };
  return (
    <button onClick={onClick} className="restartSubscriptionButton">
      <img src="/account/static/images/arrow-restart.svg" className="restartSubscriptionIcon" alt="restart-arrow" />
      Restart Verification
    </button>
  );
};

export default RestartVerificationButton;
